// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {StoreDevtoolsModule} from "@ngrx/store-devtools";

export const environment = {
  production: false,
  serverUrl: 'api/v1/',
  dadataToken: 'Token ccb1e869656ee2ab24922f540672bda545149313',
  modules: [
    StoreDevtoolsModule.instrument({
      name: 'NgRx Lk-agent',
      logOnly: true
    , connectInZone: true}),
    ]
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
